<template>
    <vx-card id="loader">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3>Результаты выполнения заданий</h3>
            </div>
        </div>

        <form>
            <div class="vx-row mt-1">
                <div class="vx-col w-1/2">
                    <div class="vx-row">
                        <!-- <div class="mt-1 w-5/6 vx-col">
                            <vs-input
                                v-model="form.name"
                                autocomplete="off"
                                label="Поиск"
                                placeholder="Введите строку поиска..."
                                class="mt-1 w-full"
                                v-on:keyup.enter="search()"
                            />
                        </div>
                        <div class="pt-10">
                            <vx-tooltip text="Очистить" position="top" delay=".3s">
                                <feather-icon
                                    icon="XIcon"
                                    @click="form.name = ''"
                                    class="inline-block text-danger cursor-pointer"
                                    svgClasses="w-5 h-5"
                                />
                            </vx-tooltip>
                        </div> -->

                        <div class="vx-col w-1/4">
                            <label class="vs-input--label">
                                Статус
                            </label>
                            <v-select
                                :options="dicts.statuses"
                                placeholder="Выберите статус"
                                class="w-full"
                                v-model="form.status">
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>

             <div class="vx-row mt-1">
                <div class="vx-col w-5/6 mb-1">
                   <div class="mt-3">
                        <vs-button class="mt-2" color="success" @click="search()" type="filled"> Применить </vs-button>
                    </div>  
                </div>

                <div class="vx-col w-1/6 mb-1">
                    <div class="mt-1 pt-3">
                        <v-select
                            :options="dicts.pageSizes"
                            label="name"
                            placeholder="На странице..."
                            class="w-full"
                            v-model="pageSize"
                            :clearable="false"
                            @input="changePageSize()"
                        >
                        </v-select>
                    </div>
                </div>
            </div> 
        </form>
        <vs-table stripe :data="items" class="mt-1 mb-3">
            <template slot="thead">
                <vs-th class="vs-lg-1"> Id </vs-th>
                <vs-th class="vs-lg-4"> Задание </vs-th>
                <vs-th class="vs-lg-1"> Пользователь </vs-th>
                <vs-th class="vs-lg-1"> Статус </vs-th>
                <vs-th class="vs-lg-3"> Результат </vs-th>
                <vs-th class="vs-lg-1"> Дата добавления </vs-th>
                <vs-th class="vs-lg-1"> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>
                        <div class="overflow-wrap">
                            <b><small class="text-bold">{{ getTranslation(tr.reviewTask).title }} </small></b><br/>
                            <small>{{ getTranslation(tr.reviewTask).description }}</small><br/>
                            <small>{{ getTranslation(tr.reviewTask).helpText }}</small><br/>
                            <small v-for="reward in tr.reviewTask.rewards">
                                {{ reward.amount }} {{ reward.currency }}
                            </small>
                        </div>
                    </vs-td>
                    <vs-td>
                        {{ tr.userName }} <br> 
                        <small>{{ tr.nickname }} (Partnerkin)</small>
                    </vs-td>
                    <vs-td>
                        <div v-bind:class="{ 'text-success': tr.status == 'approved', 'text-danger': tr.status == 'rejected' }">
                            {{ tr.status }}
                        </div>
                        <small v-if="tr.moderatorName">модератор: {{ tr.moderatorName }}</small><br>
                        <small v-if="tr.rejectionReason">{{ tr.rejectionReason }}</small>
                    </vs-td>
                    <vs-td>
                        <div class="float-left">
                            <a v-if="tr.reviewUrl" target="_blank" :href="tr.reviewUrl">Ссылка на результат</a>
                        </div>
                        <div>
                            <img v-if="tr.screenshotFullPath" class="image-preview" :src="tr.screenshotFullPath" width="246" />
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.createdAt | moment('DD.MM.YYYY') }}</vs-td>
                    <vs-td class="action-col">
                        <div>
                            <div v-if="tr.status == 'moderation'" class="inline-block cursor-pointer">
                                <vx-tooltip text="Подтвердить" position="top" delay=".3s">
                                    <feather-icon @click="showApproveModal(tr)" icon="CheckSquareIcon" class="inline-block mr-2 text-success" svgClasses="w-7 h-7"/>
                                </vx-tooltip>
                            </div>
                            <div v-if="tr.status == 'moderation'" class="inline-block cursor-pointer">
                                <vx-tooltip text="Отклонить" position="top" delay=".3s">
                                    <feather-icon @click="showRejectModal(tr)" icon="MinusSquareIcon" class="inline-block mr-2 text-danger" svgClasses="w-7 h-7"/>
                                </vx-tooltip>
                            </div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="approveModal" icon="success" title="Подтверджение выполнения задания">
            <div class="mb-5">Вы действительно хотите подтвердить результат выполнения задания id={{selected.id}}?</div>

            <vs-button class="" color="success" @click="moderate(selected, 'approved')" type="filled">
                Подтвердить
            </vs-button>
        </sweet-modal>

        <sweet-modal ref="rejectModal" icon="error" title="Отклонение результата выполнения задания">
            <div class="mb-5">Вы действительно хотите отклонить результат выполнения задания id={{selected.id}}?</div>

            <div class="vx-row mt-3 mb-2">
                <div class="vx-col w-full">
                    <label class="bld">Введите причину отклонения:</label>
                    <br />
                    <div class="mt-1">
                        <vs-input v-model="rejectionReason" class="mt-1 w-full" />
                    </div>
                </div>
            </div>

            <vs-button class="" color="danger" @click="moderate(selected, 'rejected')" type="filled">
                Отклонить
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'review-tasks-results',
    data() {
        return {
            items: [],
            selected: {},
            page: 1,
            pageSize: 25,
            pagesTotal: 1,
            rejectionReason: '',
            form: {
                status: ''
            },
            dicts: {
                statuses: [],
                pageSizes: [25, 50, 100, 500]
            }
        };
    },
    components: {
        SweetModal,
        SweetModalTab,
        vSelect
    },
    methods: {
        search() {
            this.loadData();
            this.page = 1;
        },
        loadDicts() {
            this.axios
                .all([this.axios.get('review-tasks/dicts')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.statuses = dicts.data.statuses;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                status: this.form.status,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('review-tasks/results', {
                        params: params
                    }),
                    this.axios.get('review-tasks/results/count', {
                        params: params
                    })
                ])
                .then(
                    axios.spread((items, count) => {
                        this.items = items.data;
                        this.pagesTotal = Math.floor(count.data / this.pageSize) + 1;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки результато выполнения заданий.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        getTranslation(task) {
            if (!task.translations) {
                return {};
            }

            var translation = task.translations.find(t => t.locale = 'ru');
            if (translation) {
                return translation;
            }

            return {};
        },
        changePageSize() {
            this.page = 1;

            this.loadData();
        },
        showApproveModal(item) {
            this.selected = item;
            this.$refs.approveModal.open();
        },
        showRejectModal(item) {
            this.selected = item;
            this.$refs.rejectModal.open();
        },
        closeModals() {
            this.$refs.approveModal.close();
            this.$refs.rejectModal.close();
            this.rejectionReason = '';
        },
        moderate(item, status) {
            if (status == 'rejected' && !this.rejectionReason) {
                return this.$vs.notify({
                    title: "Внимание!",
                    text: "Необходимо указать причину отклонения!",
                    color: "danger",
                });
            }

            const params = {
                id: item.id,
                status: status,
                rejectionReason: this.rejectionReason
            };

            this.$axios({
                method: 'PATCH',
                url: 'review-tasks/' + item.id + '/moderate',
                params: params,
                errors: this.errors,
                success: () => {
                    this.closeModals();
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно",
                        text: "Статус успешно изменен.",
                        color: "success",
                    });
                    this.loadData();
                },
                catch: (err) => {
                    this.closeModals();
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: error,
                            color: "danger",
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при модерации задания!",
                        color: "danger",
                    });
                }
            })
        },
    },
    watch: {
        page: function () {
            this.loadData();
        }
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.campaign-name {
    text-decoration: underline;
}

.action-col {
    min-width: 120px;
}

.vs-pagination--mb {
    justify-content: center !important;
}
</style>

<style scoped>
.filters-buttons {
    padding-top: 20px;
}

tr>>>.vs-table--td {
    width: 5%;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px;
}

th>>>.vs-table-text {
    text-align: right;
    float: right;
}

div>>>.vs-pagination-primary {
    margin-top: 10px;
}

.overflow-wrap {
    overflow-wrap: anywhere;
}

</style>
